module.exports = {"name":"SMS","menu_entries":{"sms":"SMS"}}